import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { noop } from 'lodash';
import React, { createContext, useContext } from 'react';

type Client = ApolloClient<NormalizedCacheObject>;

export interface ApolloContext {
  client?: Client;
}

const ApolloServerContext = createContext<{ setClient?: (client: Client) => void }>({
  setClient: noop
});

export const ApolloServerProvider: React.FC<{
  children: React.ReactNode;
  context: ApolloContext;
}> = ({ children, context }) => (
  <ApolloServerContext.Provider
    value={{
      setClient: (client: Client) => {
        if (!context.client) context.client = client;
      }
    }}
  >
    {children}
  </ApolloServerContext.Provider>
);

export const useApolloServerContext = () => useContext(ApolloServerContext);
